import {Numbers} from "../../..";
import type {DKK, PackageTemplate, Partner, Service} from "./index";
import {Product} from "./product";

/**
 * These are Klippecards sold through the bookingflow.
 *
 * Yoga and Training klippecards has different visual representation in the flow, than Massage klippecards.
 *
 * A klippecard is sold as a number of pre-paid services, with a discount.
 * The more services the customer pays in advance, the more discount the customer gets.
 * A klippecard is always selected for a given servicetype, a given partner and a given multiplier,
 * but later it can be used for other services or partners as well.
 *
 * Klippecards are transalted into credits (instead of clips) in the background.
 */
export class Package extends Product {
  id: number;
  packageName: string;
  multiplier: number;
  discountPercentage: number;
  partner: Partner;
  public readonly type = "Package";

  private constructor(service: Service, id: number, packageName: string, multiplier: number, discountPercentage: number, partner: Partner) {
    super(service);
    this.id = id;
    this.packageName = packageName;
    this.multiplier = multiplier;
    this.discountPercentage = discountPercentage;
    this.partner = partner;
  }

  static fromPackageTemplate = (packageTemplate: PackageTemplate, partner: Partner): Package => {
    const {service, id, packageName, multiplier, discountPercentage} = packageTemplate;
    return new Package(service, id, packageName, multiplier, discountPercentage, partner);
  };

  private get basePrice(): number {
    return this.partner.getPrice(this.service) * this.multiplier;
  }

  public getPrice(): DKK {
    const price: DKK = this.basePrice - (this.discountPercentage * this.basePrice) / 100;
    const priceEndingOn8 = Numbers.floorToNearest8(price);
    return priceEndingOn8;
  }

  public getDiscountAmount(): DKK {
    return this.basePrice - this.getPrice();
  }
}
